import type { PlanId } from '@tandemone/types'
import { useNavigate } from 'react-router'

import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from '@/components/ui/dialog'

/* the one prompt for every blocked-by-plan action. */
export function UpgradeDialog({
  open,
  onOpenChange,
  title = 'Upgrade to continue',
  description,
  planId = 'supplier_pro'
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title?: string
  description: string
  planId?: PlanId
}) {
  const navigate = useNavigate()

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='sm:max-w-[420px]'>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant='outline' onClick={() => onOpenChange(false)}>
            Not now
          </Button>
          <Button onClick={() => navigate(`/billing?upgrade=${planId}`)}>
            View plans
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
